// Seasons run from startMonth (July by default) to the month before. Key format '2025-26'.
import { type IsoDate } from './time'

export type SeasonKey = string

export function seasonOf(date: IsoDate, startMonth = 7): SeasonKey {
  const year = Number(date.slice(0, 4))
  const month = Number(date.slice(5, 7))
  const start = month >= startMonth ? year : year - 1
  return startMonth === 1 ? String(start) : `${start}-${String((start + 1) % 100).padStart(2, '0')}`
}

/** [startsOn, endsOn) of a season key. */
export function seasonRange(key: SeasonKey, startMonth = 7): { startsOn: IsoDate; endsOn: IsoDate } {
  const start = Number(key.slice(0, 4))
  const mm = String(startMonth).padStart(2, '0')
  return { startsOn: `${start}-${mm}-01`, endsOn: `${start + 1}-${mm}-01` }
}

export function isSeasonKey(value: string): boolean {
  return /^\d{4}(-\d{2})?$/.test(value)
}

export function previousSeason(key: SeasonKey): SeasonKey {
  const start = Number(key.slice(0, 4)) - 1
  return key.length === 4 ? String(start) : `${start}-${String((start + 1) % 100).padStart(2, '0')}`
}

/** '2025-26' → 'Saison 2025/26' */
export function seasonLabel(key: SeasonKey): string {
  return 'Saison ' + key.replace('-', '/')
}
